import 'babel-polyfill'
import 'bootstrap'
import { Pagination, Swiper, Navigation } from 'swiper'
var Sticky = require('sticky-js');
// Styling
import '../scss/style.scss'

// Fontawesome
import { faMagnifyingGlass, faStar, faStarHalfStroke } from '@fortawesome/free-solid-svg-icons'
import { faStar as farStar } from '@fortawesome/free-regular-svg-icons'
import { dom, library } from '@fortawesome/fontawesome-svg-core'
import { faFacebookF, faInstagram, faLinkedinIn, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
library.add(faFacebookF, faInstagram, faLinkedinIn, faStar, faStarHalfStroke, farStar, faWhatsapp, faMagnifyingGlass)
dom.watch()


// General
jQuery(document).ready(function ($) {
  let navbarToggler = document.querySelector(".navbar.full-screen .navbar-toggler");
  if (navbarToggler) {
      navbarToggler.addEventListener("click", e => {
          e.currentTarget.ariaExpanded = !(e.currentTarget.ariaExpanded === "true")
          if (e.currentTarget.ariaExpanded === "true") {
              document.children[0].classList.add("navBlock")
          } else {
              document.children[0].classList.remove("navBlock")
          }
      })
  }
  if ($('.login.wp-core-ui').length) {
    $('#user_login').attr('placeholder', 'Gebruikersnaam of e-mailadres');
    $('#user_pass').attr('placeholder', 'Wachtwoord')
  }

  //product swiper
  var product_swiper = document.querySelector(".product-swiper")
  if (product_swiper) {
    new Swiper(product_swiper, {
      modules: [Pagination, Navigation],
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerView: 1.3,
      breakpoints: {

        992: {
          slidesPerView: 4,
        },
        
        1200: {
          slidesPerView: 5,
        },
        2000: {
          slidesPerView: 8,
        }
      },
      spaceBetween: 15,
      centeredSlides: true,
      initialSlide: 2,
      loop: true,
      loopedSlides: 4,

      pagination: {
        el: ".product-pagination",
        clickable: true,
      },
    });
  }

  // project swiper
  var project_swiper = document.querySelector(".project-swiper")
  if (project_swiper) {
    new Swiper(project_swiper, {
      modules: [Pagination, Navigation],
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerView: 1.2,
      breakpoints: {
        992: {
          slidesPerView: 2.2,
        },
        2000: {
          slidesPerView: 3.3,
        }
      },
      spaceBetween: 15,
      centeredSlides: true,
      initialSlide: 1,
      // loop: true,

      pagination: {
        el: ".product-pagination",
        clickable: true,
      },
    });
  }
  var testimonial_swiper = document.querySelector(".testimonial-swiper")
  if (testimonial_swiper) {
    new Swiper(testimonial_swiper, {
      modules: [Pagination, Navigation],
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerView: 1.3,
      breakpoints: {
        992: {
          slidesPerView: 2.3,
        },
        2000: {
          slidesPerView: 3.3,
        }
      },
      spaceBetween: 15,
      centeredSlides: true,
      initialSlide: 1,
      loop: true,
      pagination: {
        el: ".testimonial-pagination",
        clickable: true,
      },
    });
  }

  let filterBtn = document.querySelector(".filter-btn");
  if (filterBtn) {
    filterBtn.addEventListener("click", e => {
      document.querySelector(".side-filter").classList.add("show")
      document.children[0].classList.add("navBlock")
    })
    let closeFilterBtn = document.querySelector(".filter-close")
    closeFilterBtn.addEventListener("click", e => {
      document.querySelector(".side-filter").classList.remove("show")
      document.children[0].classList.remove("navBlock")
    })
  }

  $('.shop-filter__filter .shop-filter__filter-title').click(function () {
    function toggleSlide(container, content, parent = null, closeState = "0") {
      if (!container.classList.contains('active')) {
        container.classList.add('active');

        var height = content.clientHeight;
        if (height == 0 || height == Number((content.style.height).replace("px", "")) || 0 == Number((content.style.height).replace("px", ""))) {
          let children = content.children;
          height = 0;
          if (children.length > 0) {
            Array.from(children).forEach(x => {
              height += x.clientHeight;
            })
          }
        }
        content.style.height = closeState = "px";

        setTimeout(function () {
          if (parent) {
            parent.style.height = (height + 20) + "px";
          }
          content.style.height = height + "px";
        }, 0);
      } else {
        content.style.height = closeState + "px";
        if (parent) {
          parent.style.height = (Number(closeState) + 20) + "px";
        }
        // content.addEventListener('transitionend', function () {
        container.classList.remove('active');
        // }, {
        //   once: true
        // });
      }
    };
    toggleSlide(this, this.nextElementSibling)
  })
  let applyBtn = document.querySelector(".shop-filter__bottom .apply")
  if (applyBtn) {
    applyBtn.addEventListener("click", e => {
      //do filtering / ajax
      let searchParams = new URLSearchParams()
      document.querySelectorAll(".shop-filter__filter :checked").forEach(x => {
        console.log(x)
        // vars.push([x.name,x.value]);
        searchParams.append(x.name, x.value)
      });
      let url = window.location.pathname + "?" + searchParams.toString();
      window.location.href = url;
    })
  }
  $(".shop-filter__filter input").on("change",e=>{
    applyBtn.click()
  })
  let resetBtn = document.querySelector(".shop-filter__bottom .reset")
  if (resetBtn) {
    resetBtn.addEventListener("click", e => {
      //remove filters and re apply
      document.querySelectorAll(".shop-filter__filter input").forEach(x => x.checked = false)
      applyBtn.click()
    })
  }
  let productThumbnail = document.querySelector(".product_thumb_slider")
  if (productThumbnail) {
    var product_thumb_slider = new Swiper(productThumbnail, {
      modules: [Pagination, Navigation],
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerView: 1,
      loop: true,

      pagination: {
        el: ".product-thumb-pagination",
        clickable: true,
      },
    });
  }

  if ($('.view-offerte').length) {
    document.querySelector(".view-offerte").addEventListener("click", e => {
      // toggleSlide()
      let content = document.getElementById("offerte");
      if (content.classList.contains("active")) {
        return
      }
      content.classList.add('active');

      content.style.height = 'auto';
      var height = content.clientHeight + 'px';

      content.style.height = '0px';

      setTimeout(function () {
        content.style.height = height;
      }, 0);
    })
  }
  let infoTabs = document.querySelectorAll(".info-table .tabs .tab");
  infoTabs.forEach(x => {
    x.addEventListener("click", e => {
      let id = x.dataset.id;
      let container = document.querySelector(".info-table .tab-content[data-id='" + id + "']");
      document.querySelector(".tab-content.active").classList.remove("active");
      container.classList.add("active");
      document.querySelector(".info-table .tabs .tab.active").classList.remove("active")
      x.classList.add("active")
    })
  })


  let lastCollapsible;
  if ($('.collapsibles__item-header').length) {
    function toggleSlide(container) {
      let content = container.querySelector(".collapsibles__item-content");
      if (!container.classList.contains('active')) {
        container.classList.add('active');

        content.style.height = 'auto';

        var height = content.clientHeight + 'px';

        content.style.height = '0px';

        setTimeout(function () {
          content.style.height = height;
        }, 0);
      } else {
        content.style.height = '0px';

        // content.addEventListener('transitionend', function () {
        container.classList.remove('active');
        // }, {
        //   once: true
        // });
      }
    };
    $('.collapsibles__item-header').click(function () {
      // $('.collapsibles__item').removeClass('active');
      if (typeof lastCollapsible !== typeof undefined && !lastCollapsible.isEqualNode(this)) {
        let container = lastCollapsible.parentElement;
        let content = container.querySelector(".collapsibles__item-content");
        content.style.height = '0px';

        // content.addEventListener('transitionend', function () {
        container.classList.remove('active');
      }
      // $(this).parent().toggleClass('active');
      toggleSlide(this.parentElement)

      lastCollapsible = this;

    });
    let tabBtns = document.querySelectorAll(".faq-cat");
    tabBtns.forEach(x => {
      x.addEventListener("click", e => {
        tabBtns.forEach(z => {
          z.classList.remove("active");
        })
        x.classList.add("active")
        document.querySelector(".faq-tab-content.active").classList.remove("active")
        document.querySelector(".faq-tab-content[data-id='" + x.dataset.id + "']").classList.add("active")
      })
    })
    let faqSelect = document.querySelector(".faq-cat-mob");
    if (faqSelect) {
      faqSelect.addEventListener("change", e => {
        tabBtns.forEach(z => {
          z.classList.remove("active");
        })
        document.querySelector(".faq-tab-content.active").classList.remove("active")
        document.querySelector(".faq-tab-content[data-id='" + faqSelect.value + "']").classList.add("active")
      })
    }
    document.querySelectorAll(".collapsibles__item.active").forEach(container => {
      let content = container.querySelector(".collapsibles__item-content");
      var height = content.clientHeight + 'px';
      content.style.height = height;
    })

    window.addEventListener("resize", e => {
      document.querySelectorAll(".collapsibles__item.active").forEach(container => {
        let content = container.querySelector(".collapsibles__item-content");
        content.style.height = "auto";
        var height = content.clientHeight + 'px';
        content.style.height = height;
      })
    })
  }

  let btnForm = document.querySelectorAll(".btn-form").forEach(x => {
    x.addEventListener("click", e => {
      x.closest("form").querySelector("input[type='submit']").click()
      x.disabled=true;
      x.classList.add("disabled")
    })
  })

  var tags = $('.slide')
    $(document).on('scroll', onScrollAnimate)
    function onScrollAnimate() {
        var pageTop = $(document).scrollTop()
        if(window.scrollX>0){
          window.scrollBy(-window.scrollX,0);
        }
        if (pageTop > 1) {
          document.querySelector(".around-header").classList.add('scrolled');
        }
        else {
          document.querySelector(".around-header").classList.remove('scrolled');
        }
        var pageBottom = pageTop + $(window).height()
        for (var i = 0; i < tags.length; i++) {
            var tag = tags[i]
            if ($(tag).offset().top < pageBottom - (window.innerHeight) * 0.05) {
                tag.classList.add('visable')
                tag.ontransitionend = function(e) {
                    e.currentTarget.classList.remove('slide')
                }
            }
            if (tag.dataset.instant) {
                tag.classList.add('visable')
            }
        }
    }
    setTimeout(() => {
        for (let i = 0; i < 10; i++) {
            onScrollAnimate();
        }
    }, 750)
  let filterText =document.querySelector(".shop-filter-header-mobile");
  if(filterText){
    if(window.innerWidth<1200){
      document.querySelector(".shop-filter__bottom").style.display="none";
      filterText.classList.add("closed")
    }
    filterText.addEventListener("click",e=>{
      if(window.innerWidth<1200){
        $(".shop-filter__bottom").slideToggle();
        filterText.classList.toggle("closed")
      }
    })
    
  }
})

var sticky = new Sticky('.sticky');
